import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GetTravellerIdentityInfoDisplayModePipe } from './get-traveller-identity-info-display-mode.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        GetTravellerIdentityInfoDisplayModePipe,
    ],
    exports: [
        GetTravellerIdentityInfoDisplayModePipe,
    ],
})
export class GetTravellerIndentityInfoDisplayModeModule {}